import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const Barcode = ({ barcodeNo, className }) => {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (!barcodeRef.current || !barcodeNo) return;

    JsBarcode(barcodeRef.current, String(barcodeNo), {
      format: 'CODE128',
      width: 1.4,
      height: 60,
      displayValue: false,
      margin: 10,
      lineColor: '#000000',
      background: '#ffffff',
    });
  }, [barcodeNo]);

  return <svg ref={barcodeRef} className={className} />;
};

export default Barcode;
